import React, { useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const Elimination = ({ eliminationData }) => {
  const tabs = [
    { key: "tab1", label: "50-50" },
    { key: "tab2", label: "1-OPT Eliminate" },
  ];
  const [activeTab, setActiveTab] = useState("tab1");
  const data = [
    {
      label: "100% Sure",
      value1:
        `${eliminationData?.qa?.["100%Sure"]?.fiftyFifty?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.["100%Sure"]?.fiftyFifty?.incorrectPercentage}` || 0,
    },
    {
      label: "Logic Play",
      value1:
        `${eliminationData?.qa?.logicPlay?.fiftyFifty?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.logicPlay?.fiftyFifty?.incorrectPercentage}` || 0,
    },
    {
      label: "Intuition Hit",
      value1:
        `${eliminationData?.qa?.intuitionHit?.fiftyFifty?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.intuitionHit?.fiftyFifty?.incorrectPercentage}` ||
        0,
    },
    {
      label: "Blind Fire",
      value1:
        `${eliminationData?.qa?.blindFire?.fiftyFifty?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.blindFire?.fiftyFifty?.incorrectPercentage}` || 0,
    },
  ];
  const eliminateData = [
    {
      label: "100% Sure",
      value1:
        `${eliminationData?.qa?.["100%Sure"]?.oneEliminate?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.["100%Sure"]?.oneEliminate?.incorrectPercentage}` || 0,
    },
    {
      label: "Logic Play",
      value1:
        `${eliminationData?.qa?.logicPlay?.oneEliminate?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.logicPlay?.oneEliminate?.incorrectPercentage}` || 0,
    },
    {
      label: "Intuition Hit",
      value1:
        `${eliminationData?.qa?.intuitionHit?.oneEliminate?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.intuitionHit?.oneEliminate?.incorrectPercentage}` ||
        0,
    },
    {
      label: "Blind Fire",
      value1:
        `${eliminationData?.qa?.blindFire?.oneEliminate?.correctPercentage}%` || 0,
      value2:
        `${eliminationData?.qa?.blindFire?.oneEliminate?.incorrectPercentage}` || 0,
    },
  ];
  return (
    <div>
      <div className="flex flex-wrap gap-2 lg:gap-4 border-b mt-7">
        {tabs?.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab?.key)}
            className={`px-3 py-1 flex justify-center font-semibold text-md items-center transition duration-300 ${
              activeTab === tab?.key
                ? "border-b-2 border-[#124699]"
                : "text-gray-700"
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      {activeTab === "tab1" && (
      <div className="flex flex-col items-center justify-center bg-white text-black p-6">
        {eliminationData?.qaTypeMetrics?.map((item, index) => {
          return (
            <div className="flex gap-10 mb-6" key={index}>
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 mb-2">
                  <CircularProgressbar
                    value={item?.fiftyFifty?.correctPercentage}
                    text={`${(item?.fiftyFifty?.correctPercentage).toFixed(
                      2
                    )}%`}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#f97316",
                      trailColor: "#10b981",
                    })}
                  />
                </div>
                <p className="text-md font-medium mt-4">
                  {item?.fiftyRightEliminatedYes}/{item?.totalFiftyQuestions}
                </p>
                <p className="text-md font-medium">
                  Your Correct Elimination Accuracy
                </p>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-24 h-24 mb-2">
                  <CircularProgressbar
                    value={item?.fiftyFifty?.incorrectPercentage}
                    text={`${(item?.fiftyFifty?.incorrectPercentage).toFixed(
                      2
                    )}%`}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#f97316",
                      trailColor: "#10b981",
                    })}
                  />
                </div>
                <p className="text-md font-medium mt-4">
                  {item?.fiftyRightChosenAfterEliminationYes}/
                  {item?.fiftyRightEliminatedYes}
                </p>
                <p className="text-md font-medium">
                  Right Answer Accuracy After Elimination
                </p>
              </div>
            </div>
          );
        })}
        <div className="grid md:grid-cols-4 grid-cols-2 gap-6 w-full">
          {data.map((item, index) => {
            return (
              <div key={index} className="text-center">
                <div className="flex items-end h-48 justify-center gap-2">
                  <div
                    className="bg-[#124699] w-8 rounded-md"
                    style={{
                      height: `${parseFloat(item?.value1 || 0)}%`,
                    }}
                  ></div>
                  <div
                    className="bg-green-500 w-8 rounded-md"
                    style={{ height: `${parseFloat(item?.value2 || 0)}%` }}
                  ></div>
                </div>
                <p className="mt-1 font-semibold">{item.label}</p>
              </div>
            );
          })}
        </div>
      </div>
      )}
      {activeTab === "tab2" && (
        <div className="flex flex-col items-center justify-center bg-white text-black p-6">
        {eliminationData?.qaTypeMetrics?.map((item, index) => {
          return (
            <div className="flex gap-10 mb-6" key={index}>
              <div className="flex flex-col items-center">
                <div className="w-24 h-24 mb-2">
                  <CircularProgressbar
                    value={item?.oneEliminate?.correctPercentage}
                    text={`${(item?.oneEliminate?.correctPercentage).toFixed(
                      2
                    )}%`}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#f97316",
                      trailColor: "#10b981",
                    })}
                  />
                </div>
                <p className="text-md font-medium mt-4">
                  {item?.oneEliminateCorrectEliminationYes}/{item?.totalOneEliminateQuestions}
                </p>
                <p className="text-md font-medium">
                  Your Correct Elimination Accuracy
                </p>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-24 h-24 mb-2">
                  <CircularProgressbar
                    value={item?.oneEliminate?.incorrectPercentage}
                    text={`${(item?.oneEliminate?.incorrectPercentage).toFixed(
                      2
                    )}%`}
                    styles={buildStyles({
                      textColor: "#000",
                      pathColor: "#f97316",
                      trailColor: "#10b981",
                    })}
                  />
                </div>
                <p className="text-md font-medium mt-4">
                  {item?.oneEliminateRightAnswerFromCorrectEliminationYes}/
                  {item?.oneEliminateCorrectEliminationYes}
                </p>
                <p className="text-md font-medium">
                  Right Answer Accuracy After Elimination
                </p>
              </div>
            </div>
          );
        })}
        <div className="grid md:grid-cols-4 grid-cols-2 gap-6 w-full">
          {eliminateData.map((item, index) => {
            return (
              <div key={index} className="text-center">
                <div className="flex items-end h-48 justify-center gap-2">
                  <div
                    className="bg-green-500 w-8 rounded-md"
                    style={{
                      height: `${parseFloat(item?.value1 || 0)}%`,
                    }}
                  ></div>
                  <div
                    className="bg-[#124699] w-8 rounded-md"
                    style={{ height: `${parseFloat(item?.value2 || 0)}%` }}
                  ></div>
                </div>
                <p className="mt-1 font-semibold">{item.label}</p>
              </div>
            );
          })}
        </div>
      </div>
      )}
    </div>
  );
};

export default Elimination;
